import React from "react";
import mock06 from '../assets/images/Resturant.png';
import mock07 from '../assets/images/stripe.png';
import mock08 from '../assets/images/VENOM1.png';
import mock09 from '../assets/images/EazyBank.png';
import mock10 from '../assets/images/Movies.png';
import mock11 from '../assets/images/GP2.png';
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <div className="section-title">
                  <span className="line"></span>
                  <h2>
                    PROJECTS <span>/ Featured work</span>
                  </h2>
                </div>
        <div className="projects-grid">
            <div className="project">
                <a href="https://www.youtube.com/watch?v=GxzZvyIzjHU" target="_blank" rel="noreferrer" className="image"><img src={mock11} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.youtube.com/watch?v=GxzZvyIzjHU" target="_blank" rel="noreferrer"><h2>Automated Cloud-Based Practical Lab Examination Platform</h2></a>
                <p>Individual Graduation Project. A scalable cloud-based system for practical exams that automatically provisions student virtual machines, manages laboratory sessions and collects submissions using AWS, Terraform, Ansible, Spring Boot and Kubernetes.</p>
            </div>
            <div className="project">
                <a href="https://github.com/yuosef33/MoviesProject" target="_blank" rel="noreferrer" className="image"><img src={mock10} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/yuosef33/MoviesProject" target="_blank" rel="noreferrer"><h2>Moviesta  AI</h2></a>
                <p>Developed Moviesta project using Spring boot and React that combines AI chat functionality with movie recommendations using external APIs such as Gemini and TMDB.</p>
            </div>
            <div className="project">
                <a href="https://github.com/yuosef33/Microservices-Bank-app" target="_blank" rel="noreferrer" className="image"><img src={mock09} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/yuosef33/Microservices-Bank-app" target="_blank" rel="noreferrer"><h2>EazyBank MicroServices </h2></a>
                <p> Developed my first MicroServices application using spring boot, spring cloud and React EazyBank project: Track your accounts, balances, and loans.</p>
            </div>
            <div className="project">
                <a href="https://github.com/yuosef33/FullStack_CarRental" target="_blank" rel="noreferrer" className="image"><img src={mock08} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/yuosef33/FullStack_CarRental" target="_blank" rel="noreferrer"><h2>VENOM</h2></a>
                <p>This is a Car Rental app developed with React, Express, and MongoDB with admin page to manage requests.</p>
            </div>
            <div className="project">
                <a href="https://github.com/yuosef33/Stripe_SpringBoot" target="_blank" rel="noreferrer" className="image"><img src={mock07} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/yuosef33/Stripe_SpringBoot" target="_blank" rel="noreferrer"><h2>Stripe Payment Integration with Spring Boot</h2></a>
                <p>Simple Spring Boot application that demonstrates how to integrate Stripe Checkout for processing payments.</p>
            </div>
            <div className="project">
                <a href="https://github.com/yuosef33/Resturant" target="_blank" rel="noreferrer" className="image"><img src={mock06} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/yuosef33/Resturant" target="_blank" rel="noreferrer"><h2>Restoran: Meal ordering and reservation</h2></a>
                <p>My first Spring-boot app with Angular .</p>
            </div>
        </div>
    </div>
    );
}

export default Project;